import { BigNumber } from "../../classes/BigNumber";
import { Deposit } from "../../classes/Deposit";
import { Period } from "../../classes/Period";
import { iApiData, iAppContract, iTime, iToken, tAddress, tDiscountPercent } from "../../interfaces";

export enum eAppActionTypes{
	CLEAR_STATE = 'APP/CLEAR_STATE',
	SET_DISCOUNT_PERCENT = 'APP/SET_DISCOUNT_PERSENT',
	SET_USER_ADDRESS = 'APP/SET_USER_ADDRESS',
	SET_API_DATA = 'APP/SET_API_DATA',
	SET_APP_CONTRACT = 'APP/SET_APP_CONTRACT',
	SET_F_TOKEN = 'APP/SET_F_TOKEN',
	SET_U_TOKEN = 'APP/SET_U_TOKEN',
	SET_CURRENT_PERIOD = 'APP/SET_CURRENT_PERIOD',
	SET_CURRENT_TIME = 'APP/SET_CURRENT_TIME',
	SET_DEPOSITS = 'APP/SET_DEPOSITS',
	SET_IS_INITED = 'APP/SET_IS_INITED',
	SET_MIN_DEPOSIT = 'APP/SET_MIN_DEPOSIT',
	SET_KAS_ACCESS_TOKEN = 'APP/SET_KAS_ACCESS_TOKEN',
}

export type tAppAction =
	iClearStateAction |
	iSetDiscountPercentAction |
	iSetUserAddressAction |
	iSetApiDataAction |
	iSetIsInitedAction |
	iSetAppContractAction |
	iSetFTokenAction |
	iSetUTokenAction |
	iSetCurrentPeriodAction |
	iSetCurrentTimeAction |
	iSetDepositsAction |
	iSetMinDepositAction |
	iSetKasAccessTokenAction
;

interface iClearStateAction {
	type: eAppActionTypes.CLEAR_STATE
}

interface iSetDiscountPercentAction {
	type: eAppActionTypes.SET_DISCOUNT_PERCENT,
	payload: tDiscountPercent
}

interface iSetUserAddressAction {
	type: eAppActionTypes.SET_USER_ADDRESS,
	payload: tAddress
}

/* interface iSetApiData {
	type: eAppActionTypes.SET_API_DATA,
	payload: {
		// [percent as tDiscountPercent as unknown as number]: iApiData
		[`${percent as tDiscountPercent}`]: iApiData
	}
} */
interface iSetApiDataAction {
	type: eAppActionTypes.SET_API_DATA,
	payload: { percent: tDiscountPercent} & iApiData
}

interface iSetIsInitedAction {
	type: eAppActionTypes.SET_IS_INITED,
	// payload: true
	payload: boolean
}

interface iSetAppContractAction {
	type: eAppActionTypes.SET_APP_CONTRACT,
	payload: {
		percent: tDiscountPercent
		contract: iAppContract
	}
}

interface iSetFTokenAction {
	type: eAppActionTypes.SET_F_TOKEN,
	payload: {
		percent: tDiscountPercent,
		token: iToken
	}
}

interface iSetUTokenAction {
	type: eAppActionTypes.SET_U_TOKEN,
	payload: {
		percent: tDiscountPercent,
		token: iToken
	}
}

interface iSetCurrentPeriodAction {
	type: eAppActionTypes.SET_CURRENT_PERIOD,
	payload: {
		percent: tDiscountPercent,
		period: Period
	}
}

interface iSetCurrentTimeAction {
	type: eAppActionTypes.SET_CURRENT_TIME,
	payload: {
		percent: tDiscountPercent,
		time: iTime
	}
}

interface iSetDepositsAction {
	type: eAppActionTypes.SET_DEPOSITS,
	payload: {
		percent: tDiscountPercent,
		deposits: Deposit[]
	}
}

interface iSetMinDepositAction {
	type: eAppActionTypes.SET_MIN_DEPOSIT,
	payload: {
		percent: tDiscountPercent,
		amount: BigNumber
	}
}

interface iSetKasAccessTokenAction {
	type: eAppActionTypes.SET_KAS_ACCESS_TOKEN,
	payload: string
}